"use client";

import React from "react";
import { useAppStore } from "@/store/useAppStore";

export const MenuButton = () => {
  const { isMenuOpen, setIsMenuOpen } = useAppStore();
  return (
    <button
      onClick={() => setIsMenuOpen(!isMenuOpen)}
      className="flex sm:hidden w-10 h-10 items-center justify-center text-white text-xl cursor-pointer"
    >
      {isMenuOpen ? "✕" : "☰"}
    </button>
  );
};
